import type {
  LinkedinCompleteSignupDto,
  LinkedinConnectionStatusDto,
  LinkedinPendingSignupDto,
} from '@paladin-monorepo/common';
import API from '../api';
import { trackEvent } from '../analytics';

export const linkedinApi = {
  /** 404 (via axios throwing) when no pending sign-up cookie exists or it has expired. */
  async getPendingSignup(): Promise<LinkedinPendingSignupDto> {
    return API.get<LinkedinPendingSignupDto>('/auth/linkedin/pending-signup').then((res) => res.data);
  },

  async completeSignup(dto: LinkedinCompleteSignupDto) {
    return API.post('/auth/linkedin/complete-signup', dto).then((res) => {
      trackEvent('sign_up', { method: 'linkedin' });
      return res.data;
    });
  },

  async getConnectionStatus(): Promise<LinkedinConnectionStatusDto> {
    return API.get<LinkedinConnectionStatusDto>('/me/linkedin/status').then((res) => res.data);
  },

  async disconnect(): Promise<void> {
    await API.delete('/me/linkedin');
  },
};
